var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tick",staticClass:"tick"},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-repeat":"true","aria-hidden":"true"}},[_c('span',{attrs:{"data-view":"flip"}})])
}]

export { render, staticRenderFns }